import { AppConfig } from "app-config";

export function getNamespacedKey(key: string): string {
  return `${AppConfig.Namespace}-${key}`;
}
